export default __webpack_public_path__ + "static/media/PAYE_format_Template.ed11eb6f.xlsx";